import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  upcomingEvents: [],
  pastEvents: [],
  loading: false,
  error: null,
};

const getEvents = createAction("getAllEventsRequest");
const getEventsSuccess = createAction("getAllEventsSuccess");
const getEventsFailure = createAction("getAllEventsFailure");

export const eventsReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Events
    .addCase(getEvents, (state, action) => {
      state.loading = true;
    })
    .addCase(getEventsSuccess, (state, action) => {
      state.loading = false;
      state.upcomingEvents = action.payload?.upcomingEvents;
      state.pastEvents = action.payload?.pastEvents;
    })
    .addCase(getEventsFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
